import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import HomePage from "@/pages/HomePage";
import PostPage from "@/pages/PostPage";
import AdminNewsletterPage from "@/pages/AdminNewsletterPage";
import AdminRequestsPage from "@/pages/AdminRequestsPage";
import TalkPage from "@/pages/TalkPage";
import QuestionsPage from "@/pages/QuestionsPage";
import AdminMessagesPage from "@/pages/AdminMessagesPage";
import AdminQuestionsPage from "@/pages/AdminQuestionsPage";
import AboutPage from "@/pages/AboutPage";
import LoginPage from "@/pages/LoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminPostEditor from "@/pages/AdminPostEditor";
import SponsorPage from "@/pages/SponsorPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import AdminPaymentsPage from "@/pages/AdminPaymentsPage";
import AdminSettingsPage from "@/pages/AdminSettingsPage";
import AdminCommentsPage from "@/pages/AdminCommentsPage";
import AdminSubscribersPage from "@/pages/AdminSubscribersPage";
import AdminStatsPage from "@/pages/AdminStatsPage";
import AdminAssistantPage from "@/pages/AdminAssistantPage";
import UnsubscribePage from "@/pages/UnsubscribePage";
import AdminPersonalizePage from "@/pages/AdminPersonalizePage";
import GalleryPage from "@/pages/GalleryPage";
import AdminGalleryPage from "@/pages/AdminGalleryPage";
import { api } from "@/lib/api";
import { applyTheme } from "@/lib/themes";

const ThemeApplier = () => {
  React.useEffect(() => {
    api
      .get("/site-settings")
      .then((r) => applyTheme(r.data))
      .catch(() => {});
  }, []);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeApplier />
        <div className="flex min-h-screen flex-col bg-[#0D0907] text-[#F7F1E8]">
          <Navbar />
          <div className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/post/:slug" element={<PostPage />} />
              <Route path="/api/share/:slug" element={<PostPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/hai-la-o-cafea" element={<TalkPage />} />
              <Route path="/vorbim" element={<Navigate to="/hai-la-o-cafea" replace />} />
              <Route path="/intrebari-anonime" element={<QuestionsPage />} />
              <Route path="/galerie" element={<Navigate to="/intrebari-anonime" replace />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/sponsorizeaza" element={<Navigate to="/hai-la-o-cafea" replace />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/payment/cancel" element={<PaymentCancelPage />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/payments"
                element={
                  <ProtectedRoute>
                    <AdminPaymentsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/settings"
                element={
                  <ProtectedRoute>
                    <AdminSettingsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/comments"
                element={
                  <ProtectedRoute>
                    <AdminCommentsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/subscribers"
                element={
                  <ProtectedRoute>
                    <AdminSubscribersPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/stats"
                element={
                  <ProtectedRoute>
                    <AdminStatsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/asistent"
                element={
                  <ProtectedRoute>
                    <AdminAssistantPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/personalizare"
                element={
                  <ProtectedRoute>
                    <AdminPersonalizePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/galerie"
                element={
                  <ProtectedRoute>
                    <AdminGalleryPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/unsubscribe/:token" element={<UnsubscribePage />} />
              <Route
                path="/admin/new"
                element={
                  <ProtectedRoute>
                    <AdminPostEditor />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/mesaje"
                element={
                  <ProtectedRoute>
                    <AdminMessagesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/intrebari"
                element={
                  <ProtectedRoute>
                    <AdminQuestionsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/cereri"
                element={
                  <ProtectedRoute>
                    <AdminRequestsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/newsletter"
                element={
                  <ProtectedRoute>
                    <AdminNewsletterPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/edit/:id"
                element={
                  <ProtectedRoute>
                    <AdminPostEditor />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </div>
          <Footer />
        </div>
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#2B1B13",
              color: "#F7F1E8",
              border: "1px solid rgba(200, 16, 46, 0.45)",
              borderRadius: "9999px",
              fontFamily: "Outfit, sans-serif",
              fontSize: "13px",
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
